import { useState, useEffect } from 'react'
import fetchThemeInterviews from '../helpers/intelligence/fetchThemeInterviews'

/**
 * De interviews van één thema (eigen, effectbreed, niet-gereviewd) met de
 * poort van de server. Drie toestanden apart: 'geen interviews' is een
 * bewering en mag pas na een gelukte read.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * @param {string} themeId - '' = nog niet bekend, dan geen aanroep
 * @returns {{data: (object|null), loading: boolean, loaded: boolean, error: (Error|null)}}
 */
const useThemeInterviews = (themeId) => {
    const [data, setData] = useState(/** @type {object|null} */(null))
    const [loaded, setLoaded] = useState(false)
    const [error, setError] = useState(/** @type {Error|null} */(null))

    useEffect(() => {
        if (!themeId) return undefined
        let cancelled = false
        setLoaded(false)
        setError(null)
        setData(null)
        fetchThemeInterviews(themeId)
            .then((result) => {
                if (cancelled) return
                setData(result)
                setLoaded(true)
            })
            .catch((err) => {
                if (cancelled) return
                console.error('useThemeInterviews:', err)
                setError(err)
                setData(null)
                setLoaded(false)
            })
        return () => { cancelled = true }
    }, [themeId])

    return { data, loading: !loaded && error === null, loaded, error }
}

export default useThemeInterviews
